// phone-canonical.ts — fonte única da verdade pra extrair o telefone de
// destino antes de qualquer envio WhatsApp. Espelha a função PG
// whatsapp_canonicalize_phone e a função TS do edge runtime.
//
// USE SEMPRE QUE FOR ENVIAR MSG: getDestinationPhone(conversation)
// em vez de conversation.wa_id / conversation.telefone direto.

/**
 * Aplica a regra canônica BR: DDI 55 + "9" móvel obrigatório.
 * - Remove não-dígitos
 * - Trunca corrupção (>13 dígitos com 55)
 * - Adiciona DDI BR quando vier 10/11 dígitos
 * - Insere "9" depois do DDD SÓ quando o bloco de 8 dígitos for de CELULAR (6-9).
 *   FIXO começa em 2-5 e não leva o nono dígito: 555130215290 (51 3021-5290) virava
 *   5551930215290, número inexistente — foi o que matou ~69k botões de e-mail em 04/08.
 */
export function canonicalizePhoneBR(raw: string | null | undefined): string {
  if (!raw) return '';
  const semDevice = String(raw).split(':')[0];
  let digits = semDevice.replace(/[^0-9]/g, '');
  if (!digits) return '';

  if (digits.length > 13 && digits.startsWith('55')) {
    const quintoDigito = digits.substring(4, 5);
    digits = quintoDigito === '9' ? digits.substring(0, 13) : digits.substring(0, 12);
  }
  if (digits.length === 10 || digits.length === 11) {
    digits = '55' + digits;
  }
  if (digits.length === 12 && digits.startsWith('55') && '6789'.includes(digits[4])) {
    digits = digits.slice(0, 4) + '9' + digits.slice(4);
  }
  return digits;
}

/**
 * Extrai o telefone CANÔNICO de destino de uma conversa.
 * Prioridade: telefone_canonico > wa_id > telefone (todos canonicalizados).
 *
 * Use SEMPRE este helper antes de chamar uma edge de envio. Nunca passe
 * `conversation.wa_id` direto — pode estar com 12 dígitos sem o "9" móvel
 * (caso comum em conversas antigas vindas do Baileys).
 */
export function getDestinationPhone(conversation: {
  telefone_canonico?: string | null;
  wa_id?: string | null;
  telefone?: string | null;
} | null | undefined): string {
  if (!conversation) return '';
  // Banco já normaliza via trigger BEFORE INSERT/UPDATE, então normalmente
  // telefone_canonico já vem certo. Mas canonicalize de novo por segurança
  // (defesa em profundidade).
  return canonicalizePhoneBR(
    conversation.telefone_canonico ||
    conversation.wa_id ||
    conversation.telefone ||
    ''
  );
}
